import React from 'react';
import { motion } from 'framer-motion';

const BoltBadge: React.FC = () => {
  return (
    <motion.a
      href="https://bolt.new/"
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, duration: 0.5 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-4 right-4 z-50 group"
      title="Powered by Bolt"
    >
      <div className="relative">
        {/* Badge Container */}
        <div className="bg-white rounded-full p-2 shadow-lg border-2 border-gray-200 group-hover:shadow-xl transition-all duration-300">
          {/* Bolt Logo */}
          <img
            src="/white_circle_360x360.png"
            alt="Powered by Bolt"
            className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full"
          />
        </div>
        
        {/* Hover Tooltip */}
        <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-dark-900 border border-dark-600 rounded-lg text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          <div className="font-medium">Powered by Bolt</div>
          <div className="text-xs text-gray-400">Click to learn more</div>
          <div className="absolute top-full right-4 w-2 h-2 bg-dark-900 border-r border-b border-dark-600 rotate-45 transform -translate-y-1"></div>
        </div>

        {/* Pulse Animation Ring */}
        <div className="absolute inset-0 rounded-full border-2 border-primary-400 opacity-0 group-hover:opacity-100 animate-ping"></div>
      </div>
    </motion.a>
  );
};

export default BoltBadge;